"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createStateToProps = exports.asyncAction = exports.onActionMiddleware = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _reselect = require("reselect");

var _object = require("./object.js");

var onActionMiddleware = function onActionMiddleware(type, f) {
  return function (store) {
    return function (next) {
      return function (action) {
        if (action.type === type) {
          f(action);
        }

        return next(action);
      };
    };
  };
};

exports.onActionMiddleware = onActionMiddleware;

var asyncAction = function asyncAction(_ref) {
  var typePrefix = _ref.typePrefix,
      loadPayload = _ref.loadPayload,
      _ref$ifPredicate = _ref.ifPredicate,
      ifPredicate = _ref$ifPredicate === void 0 ? function () {
    return true;
  } : _ref$ifPredicate;
  return /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(dispatch, getState) {
      var type, payload;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              type = function type(step) {
                return "".concat(typePrefix, "_").concat(step);
              };

              if (ifPredicate(getState())) {
                _context.next = 3;
                break;
              }

              return _context.abrupt("return");

            case 3:
              dispatch({
                type: type("LOADING")
              });
              _context.prev = 4;
              _context.next = 7;
              return loadPayload();

            case 7:
              payload = _context.sent;
              dispatch({
                type: type("LOADED"),
                payload: payload
              });
              return _context.abrupt("return", payload);

            case 12:
              _context.prev = 12;
              _context.t0 = _context["catch"](4);
              dispatch({
                type: type("FAILED"),
                payload: {
                  error: _context.t0
                }
              });
              throw _context.t0;

            case 16:
              _context.prev = 16;
              dispatch({
                type: type("DONE")
              });
              return _context.finish(16);

            case 19:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[4, 12, 16, 19]]);
    }));

    return function (_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();
};

exports.asyncAction = asyncAction;

var createConverterSelector = function createConverterSelector(selector) {
  return (0, _reselect.createSelector)([selector], function (value) {
    return value && typeof value.toJS === "function" ? value.toJS() : value;
  });
};

var createStateToProps = function createStateToProps(propsToSelectors) {
  return function () {
    var selectorMap = (0, _object.mapValues)(propsToSelectors, createConverterSelector);
    return function (state, ownProps) {
      return (0, _object.mapValues)(selectorMap, function (selector) {
        return selector(state, ownProps);
      });
    };
  };
};

exports.createStateToProps = createStateToProps;